/*
 * @Author: Liux
 * @Date: 2019-12-05 08:34:25
 * @LastEditor: Liux
 * @LastEditTime: 2019-12-05 09:32:34
 */
export class AdDateRangeModel {
  oldStartDate?: Date;
  oldEndDate?: Date;
  startDate: Date;
  endDate: Date;
  days?: Date[];
}
